export default __webpack_public_path__ + "static/media/andrew-ly-iUA1cea8QiY-unsplash.2d259024.jpg";